module.exports = __webpack_public_path__ + "fonts/Inter-800-cyrillic54.fbe36d9.woff2";